
export default function AboutHero() {
  return (
    <section className="relative min-h-[70vh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/c9fc18319446cf4ba128ee3a03dc24ac.jpg"
          alt="About unuu creative workspace"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 via-slate-900/75 to-slate-900/40"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-32 w-full">
        <div className="max-w-2xl">
          <span className="inline-block px-4 py-1.5 border border-white/30 rounded-full text-xs font-semibold text-white/80 uppercase tracking-widest mb-6">
            Our Story
          </span>
          <h1
            className="text-5xl lg:text-6xl font-bold text-white leading-tight mb-6"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            We help brands become <span className="text-[#00d4db]">unforgettable</span>
          </h1>
          <p className="text-lg text-gray-300 leading-relaxed max-w-xl">
            Founded with a passion for authentic storytelling, unuu is a social media marketing agency that turns your brand into a conversation people want to join.
          </p>
        </div>
      </div>
    </section>
  );
}
